import DateHelper from './DateHelper';
export { ActiviteitenLog };
class ActiviteitenLog {
    constructor(data) {
        data = data ?? {};
        Object.defineProperties(this, {
            id: {
                value: data.key,
                writable: false
            },
            gemaakt: {
                value: 
                DateHelper.convertedToDateTimeShort(data.created),
                writable: false,
                enumerable: true
            },
            actie: {
                type: String,
                value: data.activity,
                writable: true,
                enumerable: true
            },
            persoon: {
                type: String,
                value: data.user,
                writable: true,
                enumerable: true
            },
            initialen: {
                type: String,
                value: data.initials,
                writable: true,
                enumerable: true
            }
        });
        this.persoonInitialen = this.initialen != undefined ? this.persoon + ' (' + this.initialen + ')' : this.persoon ;
    }
}
